module.exports = __webpack_public_path__ + "static/strahil-small-d3b9133f6a06e41e5d0b77d3d4020fba.webp";